import {AccessDeniedComponent} from './component/access-denied/access-denied.component';
import {RouterModule, Routes} from '@angular/router';
import {LoginComponent} from './component/login/login.component';

export const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'Đăng nhập'
    }
  },
  {
    path: 'access-denied',
    component: AccessDeniedComponent,
    data: {
      title: 'Access Denied',
    }
  },
];

export const AuthenticationRouting = RouterModule.forChild(routes);
